export default {
  ADD_TO_ECART: 'ECART / ADD TO ECART',
  REQUEST_ECART_SUCCESS: 'ECART / REQUEST ECART / SUCCESS',
  SET_ADDITIONNAL_LIST_ERESA: 'ECART / SET ERESA MODAL LIST',
  SET_MAIN_PRODUCT_ERESA: 'ECART / SET ERESA MAIN PRODUCT',
  SET_ERESA_REQUEST_LOADING: 'ECART / SET ERESA REQUEST LOADING',
  SET_ERESA_REQUEST_ERROR: 'ECART / SET ERESA REQUEST ERROR',
} as const;
